<template>
  <tr :class="'border-b border-gray-300 ' + (index % 2 == 0 ? 'bg-gray-100' : 'bg-white')">
  <!-- <tr class="border-b border-gray-300" v-on:click="clientSelected()"> -->
    <td class="py-4 pl-6 pr-4 border-r">
      <router-link
       :to="{ 
        name : 'broker-account',
        params : {
          brokerId : broker.id
        }
      }"
      tag="a"
      class="text-blue-600 no-underline hover:underline">{{ broker.first_name }} {{ broker.last_name }}</router-link>
    </td>

    <td class="p-4 border-r">
      <a class="text-blue-600 no-underline hover:underline" :href="'mailto:' + broker.email">{{broker.email}}</a>
    </td>

    <td class="p-4 border-r">{{ broker.recent_clients_count }}</td>
    <td class="p-4 border-r">{{ broker.registered_at }}</td>
    <td class="p-4 border-r">{{broker.trial_end_date}}</td>
    <td class="p-4 border-r">{{broker.paying}}</td>
    <td v-if="broker.referrer_broker_id != null" class="p-4 border-r">
      <router-link
        :to="{
        name : 'broker-account',
        params : {
          brokerId : broker.referrer_broker_id
        }
      }"
        tag="a"
        class="text-blue-600 no-underline hover:underline">{{ broker.referrer_first_name }} {{ broker.referrer_last_name }}</router-link>
    </td>
    <td v-else class="p-4 border-r">{{broker.referrer_code}}</td>
    <td class="p-4 border-r helpme">{{broker.source != null ? broker.source.replace(new RegExp(' - \$'), '') : broker.source}}</td>
    <td class="p-2 text-center">
      <button class="w-full bg-gray-600 text-white text-xs font-semibold hover:bg-blue-500 outline-none"
        style="padding:9px 0;" v-on:click="brokerSelected()">Actions</button>
    </td>

  </tr>
</template>

<script>

 import axios from "axios";
 import { EventBus } from '@/shared/event-bus';

  export default {

    props : {
      broker : {
        type    : Object,
        required: true
      },

      index : {
        type    : Number,
        required: true
      }
    },

    methods: {
      brokerSelected : function () {
        EventBus.$emit('open-broker-actions', this.broker)
      }

    }

  }
</script>
